import About from "../components/about/About";
import Banner from "../components/banner/Banner";
import Benefit from "../components/benefits-section/Benefit";
import CompanyPartner from "../components/company-partner/CompanyPartner";
import FaqSection from "../components/faq-section/FaqSection";
import FooterSection from "../components/footer-section/Footer";
import GridSection from "../components/grid-section/GridSection";
import Header from "../components/Header/Header";
import Midbanner from "../components/mid-banner-section/Midbanner";
import Solution from "../components/solution/Solution";

export default function AgentScrum() {
    return (
        <>
            <Header />
            <Banner />
            <CompanyPartner />
            <About />
            <Solution />
            <Benefit />
            <GridSection />
            <FaqSection />
            <Midbanner />
            <FooterSection />
        </>
    );
}
